import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import "./product_entry.css";

import MobileDatePicker from "@mui/lab/MobileDatePicker";

import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";

import { addEditStepOne, addStepOne } from "../../redux/features/product.features";
import { fetchAllTitles } from "../../redux/features/titles.features";
import { fetchAllOrigin } from "../../redux/features/origin.features";
import { fetchAllShapes } from "../../redux/features/shapes.features";
import { useDispatch, useSelector } from "react-redux";

const initialValues = {
  title: "",
  description: "",
  date: "",
  clarity: "",
  need_recut: "",
  treatment_type: "Heated",
  origin: "",
  shape: "",
  weight: 0.00,
  dimension: "",
  dimensionHeight: 0,
  dimensionWidth: 0,
  dimensionDepth: 0,
  category: "Precious",
  titles: "",
};
const ProductEditStepOne = ({ setStepOneData }) => {
  const dispatch = useDispatch();
  let productState = useSelector((state) => {
    return state.productReducer;
  });
  let titlesState = useSelector((state) => {
    return state.titlesReducer;
  });

  let shapesState = useSelector((state) => {
    return state.shapesReducer;
  });
  let originState = useSelector((state) => {
    return state.originReducer;
  });

  useEffect(() => {
    dispatch(fetchAllTitles())
    dispatch(fetchAllOrigin())
    dispatch(fetchAllShapes())

  }, [dispatch])
  

  let { titles } = titlesState;

  let { shapes } = shapesState;
  let { origin } = originState;
  let { editProduct, exportDetails } = productState;
  let { stepOne } = editProduct;

  const [titlesList, setTitlesList] = useState([]);

  const [originList, setOriginList] = useState([]);
  const [shapeList, setShapeList] = useState([]);

  useEffect(() => {
    let a = [];
    shapes.map((x) => {
      return a.push(x.shapesName);
    });
    setShapeList(a);
  }, [shapes]);

  useEffect(() => {
    let a = [];
    origin.map((x) => {
      return a.push(x.originName);
    });
    setOriginList(a);
  }, [origin]);

  useEffect(() => {
    let a = [];
    titles.map((x) => {
      return a.push(x.titlesName);
    });
    setTitlesList(a);
  }, [titles]);

  // useEffect(() => {
  //   if(!stepOne) alert("step one undefined")
  // }, [stepOne]);

  const [selectedDate, setEnterDate] = React.useState(
    stepOne?.date === null || stepOne?.date === ""
      ? new Date()
      : new Date(stepOne?.date)
  );
  // const [values, setValues] = useState(stepOne || initialValues);
  const [values, setValues] = useState(stepOne.category ==="" ? initialValues: stepOne);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setValues({
      ...values,
      [name]: value,
    });
  };

  const verifyData = () => {
    const stepOneFilledDatas = {
      _id:stepOne._id,
      productId:values.productId,
      title: values.title,
      description: values.description,
      // category: values.category,
      category: values.category ==="" ? "Precious": values.category,

      date: selectedDate,
      clarity: values.clarity,
      need_recut: values.need_recut,
      // treatment_type: values.treatment_type,
      treatment_type: values.treatment_type ==="" ? "Heated": values.treatment_type ,

      origin: values.origin,
      shape: values.shape,
      weight: values.weight,
      dimension: values.dimension,
      dimensionHeight: values.dimensionHeight,
      dimensionWidth: values.dimensionWidth,
      dimensionDepth: values.dimensionDepth,
    };

    console.log("stepOne", stepOne);
    // setStepOneData(stepOneFilledDatas);
    dispatch(addEditStepOne(stepOneFilledDatas));
  };

  useEffect(() => {
    verifyData();     
  }, [values, dispatch]);

  useEffect(() => {
    console.log("titles", titles);
    var filteredData = titles.filter(
      (x) => x.titlesCategory === values.category
    );
    console.log("filteredData", filteredData);
    var arr = [];
    filteredData.map((x) => arr.push(x.titlesName));
    console.log("arr", arr);
    setTitlesList(arr);
  }, [titles, values]);

  return (
//     <Box component="form" noValidate autoComplete="off">
      
//       <div className="mb-3 p-3 flex flex-col w-full border-2 border-spacing-3 border-gray-500" >
//         <div className="flex justify-between items-center m-2">         
//             <TextField
//               style={{marginRight:8 }}
//             fullWidth
//             required
//             id="outlined-required"
//             label="Product id"
//             defaultValue=""
//             color="warning"
//             margin="dense"
//             name="productId"
//             value={values.productId}
            
//             onChange={handleChange}
//           />
//              <MobileDatePicker
//             label="Date mobile"
//             inputFormat="dd/MM/yyyy"
//             value={selectedDate}
//             onChange={(selectedDate) => {
//               console.log(selectedDate);

//               setEnterDate(selectedDate);

//               verifyData();
//             }}
//             renderInput={(params) => <TextField {...params} />}
//           />
//                </div>
//         <div className="flex justify-between items-center m-2">
           
//               <CustomSelectBox
// style={{marginRight:8 }}                
// items={["Precious", "Semi"]}
//                 onChange={handleChange}
//                 title="Category"
//                 name="category"
//                 value={values.category}
//               />
            

//             <div className="col-6">
//               <CustomSelectBox
//                 items={titlesList}
//                 onChange={handleChange}
//                 title="Titles"
//                 name="title"
//                 value={values.title}
//               />
//             </div>
//             <div className="flex justify-between items-center m-2">       

//             <TextField
//             style={{marginRight:8 }}
//             fullWidth
//             required
//             id="outlined-required"
//             label="Weight"
//             placeholder="00.00ct"
//             defaultValue=""
//             type="number"
//             color="warning"
//             name="weight"
//             value={values.weight}
//             onChange={handleChange}
//           />

//                <CustomSelectBox
//             items={["Natural", "Heated", "?"]}
//             onChange={handleChange}
//             title="Gem Treatment Type"
//             name="treatment_type"
//             value={values.treatment_type}
//           />
//         </div>
//         <div className="flex justify-between items-center m-2">
//         <CustomSelectBox
//           style={{marginRight:8 }}
//             items={["Eye Clean", "Lupe clean"]}
//             onChange={handleChange}
//             title="Gem Clarity"
//             name="clarity"
//             value={values.clarity}
//           />
//            <CustomSelectBox
//             items={shapeList}
//             onChange={handleChange}
//             title="Gem Shape"
//             name="shape"
//             value={values.shape}
//           />
//         </div>
//         <div className="flex justify-between items-center m-2">
//         <TextField
//             style={{marginRight:8 }}
//             required
//             id="outlined-required"
//             placeholder="Height"
//             label="Dimension "
//             onChange={handleChange}
//             color="warning"
//             name="dimensionHeight"
//             value={values.dimensionHeight}
//           />

//           <TextField
//            style={{marginRight:8 }}
//             required
//             id="outlined-required"
//             placeholder="Width"
//             label="Dimension"
//             onChange={handleChange}
//             color="warning"
//             name="dimensionWidth"
//             value={values.dimensionWidth}
//           />

//           <TextField
//             style={{ color: "white",}}
//             required
//             id="outlined-required"
//             placeholder="Depth"
//             label="Dimension"
//             onChange={handleChange}
//             color="warning"
//             name="dimensionDepth"
//             value={values.dimensionDepth}
//           />
//         </div>

//         <div className="flex justify-between items-center m-2">
//         <CustomSelectBox
//           style={{marginRight:8 }}
//             items={originList}
//             onChange={handleChange}
//             title="Gem Origin"
//             name="origin"
//             value={values.origin}
//           />

//           <CustomSelectBox
//             items={["Yes", "No"]}
//             onChange={handleChange}
//             title="Need to Re-Cut"
//             name="need_recut"
//             value={values.need_recut}
//           />
//         </div>

//         <div className="flex justify-between items-center m-2">
//         <TextField
             
//              fullWidth
//              required
//              multiline={true}
//              rows={4}
//              id="outlined-required"
//              label="Description"
//              placeholder="Describe about the gem"
//              defaultValue=""
//              color="warning"
//              name="description"
//              value={values.description}
//              onChange={handleChange}
//            />
//          </div>
//        </div>
//        </div>
//      </Box>

<Box component="form" noValidate autoComplete="off">
<div className="mb-3 p-3 flex flex-col w-full border-2 border-spacing-3 border-gray-500">
  <div className="flex justify-between items-center m-2">
    <TextField
      style={{ marginRight: 8 }}
      fullWidth
      required
      id="outlined-required"
      label="Product id"
      defaultValue=""
      color="warning"
      margin="dense"
      name="id"
      disabled
      onChange={handleChange}
    />
    <MobileDatePicker
      label="Date mobile"
      inputFormat="dd/MM/yyyy"
      value={selectedDate}
      onChange={(selectedDate) => {
        console.log(selectedDate);

        setEnterDate(selectedDate);

        verifyData();
      }}
      renderInput={(params) => <TextField {...params} />}
    />
  </div>
  <div className="flex justify-between items-center m-2">
    <CustomSelectBox
      style={{ marginRight: 8 }}
      items={["Precious", "Semi"]}
      onChange={handleChange}
      title="Category"
      name="category"
      value={values.category}
    />

    <CustomSelectBox
      items={titlesList}
      onChange={handleChange}
      title="Titles"
      name="title"
      value={values.title}
    />
  </div>
  <div className="flex justify-between items-center m-2">
    
    <TextField
      style={{ marginRight: 8 }}
      fullWidth
      required
      id="outlined-required"
      label="Weight"
      placeholder="00.00ct"
      defaultValue=""
      type="number"
      color="warning"
      name="weight"
      value={values.weight}
      onChange={handleChange}
    />

    <CustomSelectBox
      items={["Natural", "Heated", "?"]}
      onChange={handleChange}
      title="Gem Treatment Type"
      name="treatment_type"
      value={values.treatment_type}
    />
  </div>
  <div className="flex justify-between items-center m-2">
    <CustomSelectBox
      style={{ marginRight: 8 }}
      items={["Eye Clean", "Lupe clean"]}
      onChange={handleChange}
      title="Gem Clarity"
      name="clarity"
      value={values.clarity}
    />
    <CustomSelectBox
      items={shapeList}
      onChange={handleChange}
      title="Gem Shape"
      name="shape"
      value={values.shape}
    />
  </div>
  <div className="flex justify-between items-center m-2">
    <TextField
      style={{ marginRight: 8 }}
      required
      id="outlined-required"
      placeholder="Height"
      label="Dimension "
      onChange={handleChange}
      color="warning"
      name="dimensionHeight"
      value={values.dimensionHeight}
    />

    <TextField
      style={{ marginRight: 8 }}
      required
      id="outlined-required"
      placeholder="Width"
      label="Dimension"
      onChange={handleChange}
      color="warning"
      name="dimensionWidth"
      value={values.dimensionWidth}
    />

    <TextField
      style={{ color: "white" }}
      required
      id="outlined-required"
      placeholder="Depth"
      label="Dimension"
      onChange={handleChange}
      color="warning"
      name="dimensionDepth"
      value={values.dimensionDepth}
    />
  </div>

  <div className="flex justify-between items-center m-2">
    <CustomSelectBox
      style={{ marginRight: 8 }}
      items={originList}
      onChange={handleChange}
      title="Gem Origin"
      name="origin"
      value={values.origin}
    />

    <CustomSelectBox
      items={["Yes", "No"]}
      onChange={handleChange}
      title="Need to Re-Cut"
      name="need_recut"
      value={values.need_recut}
    />
  </div>

  <div className="flex justify-between items-center m-2">
    <TextField
      fullWidth
      required
      multiline={true}
      rows={4}
      id="outlined-required"
      label="Description"
      placeholder="Describe about the gem"
      defaultValue=""
      color="warning"
      name="description"
      value={values.description}
      onChange={handleChange}
    />
  </div>
</div>
</Box>
     );
};
          
export default ProductEditStepOne;
